import { render, staticRenderFns } from "./tableRole.vue?vue&type=template&id=365c27d7"
import script from "./tableRole.vue?vue&type=script&lang=js"
export * from "./tableRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports